module.exports = __webpack_public_path__ + "img/phone-unlocked.1db3b2cf.jpg";